import { useEffect, useRef } from 'react';

/**
 * Gerçek zamanlı veri değişimi sinyali geldiğinde verilen callback'i çağırır.
 * Backend'deki yazma istekleri (POST/PUT/PATCH/DELETE) ve yeni bildirimler
 * `fortis:refresh` window olayını tetikler. Bu hook ile sayfalar listelerini
 * otomatik yeniler. Art arda gelen sinyaller throttle edilir.
 */
export const useRealtimeRefresh = (callback) => {
  const cbRef = useRef(callback);
  cbRef.current = callback;

  useEffect(() => {
    let last = 0;
    let pending = null;
    const handler = () => {
      const now = Date.now();
      if (now - last < 800) {
        clearTimeout(pending);
        pending = setTimeout(() => {
          last = Date.now();
          cbRef.current && cbRef.current();
        }, 800);
        return;
      }
      last = now;
      cbRef.current && cbRef.current();
    };
    window.addEventListener('fortis:refresh', handler);
    return () => {
      window.removeEventListener('fortis:refresh', handler);
      clearTimeout(pending);
    };
  }, []);
};

export default useRealtimeRefresh;
